import * as yup from "yup";

export const deliveryAddressSchema = yup.object().shape({
  college: yup.string().required("required"),
  course_type: yup.string().required("required"),
  courseName: yup.string().required("required"),
  fees: yup.string().required("required"),
});

export const loginSchema = yup.object().shape({
  mobile: yup
    .string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits"),
  name: yup
    .string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters long"),
});
export const addressSchema = yup.object().shape({
  mobile: yup
    .string()
    .required("Mobile number is required")
    .matches(/^(\+91)?[0-9]{10}$/, "Enter a valid mobile number"),
  name: yup
    .string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters long"),
  full_address: yup
    .string()
    .required("Full address is required")
    .min(10, "Atleast 10 characters long"),
  pincode: yup
    .string()
    .required("Pincode is required")
    .matches(/^[0-9]{0,6}$/, "Pincode must be 6 digits"),
});
export const shopPickupSchema = yup.object().shape({
  mobile: yup
    .string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Invalid mobile number"),
  name: yup
    .string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters long"),
});
export const OTPSchema = yup.object().shape({
  mobile: yup
    .string()
    .required("OTP is required")
    .matches(/^[0-9]{10}$/, "OTP number must be exactly 6 digits"),
});
export const pickupValidationSchema = yup.object().shape({
  contact_name: yup
    .string()
    .required("Contact name is required")
    .min(2, "Name must be at least 2 characters"),
  contact_mobile: yup
    .string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Enter a valid 10-digit mobile number"),
  pickupLocation: yup
    .string()
    .required("Please select a pickup location")
    .notOneOf([""], "Please select a valid option"),
});
export const updateProfileSchema = yup.object().shape({
  customer_email: yup.string().email("Invalid email address").notRequired(),
  customer_name: yup
    .string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters long"),
});
const gstinRegEx = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

export const gstinValidationSchema = yup.object().shape({
  gstin: yup
    .string()
    .matches(gstinRegEx, 'Invalid GSTIN')
    .required('GSTIN is required'),
  business_name: yup
    .string()
    .min(3, ({ min }) => `Must be at least ${min} characters`)
    .required('Business Name is required'),
});